export const LeaveBalanceCards = ({ bal }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6" data-testid="leave-balance-cards">
    {Object.entries(bal).map(([k, v]) => (
      <div key={k} className="rounded-2xl bg-white border border-[#E5E5EA] p-5" data-testid={`balance-${k}`}>
        <div className="text-[11px] font-bold uppercase tracking-wider text-[#6E6E73]">{v.name}</div>
        {v.unlimited ? (
          <div className="text-3xl font-extrabold mt-2">{v.used}<span className="text-sm text-[#6E6E73] font-medium"> used this year</span></div>
        ) : (
          <>
            <div className="text-3xl font-extrabold mt-2" data-testid={`balance-${k}-available`}>{v.available}<span className="text-sm text-[#6E6E73] font-medium"> available</span></div>
            <div className="h-1.5 rounded-full bg-[#F5F5F7] mt-3">
              <div className="h-1.5 rounded-full bg-[#E08A1E]" style={{ width: `${Math.min(100, (v.used / Math.max(1, v.credited + v.carried + Math.max(0, v.adjusted))) * 100)}%` }} />
            </div>
            <div className="text-[11px] text-[#6E6E73] mt-2 leading-relaxed">
              {v.accrual === "monthly" ? "Monthly credit" : `${v.annual_quota}/year`} · Used {v.used}
              {v.pending > 0 && ` · Pending ${v.pending}`}{v.carried > 0 && ` · Carried ${v.carried}`}{v.lapsed > 0 && ` · Lapsed ${v.lapsed}`}
            </div>
          </>
        )}
      </div>
    ))}
  </div>
);
